import { CheckCircleOutlined, UserOutlined } from '@ant-design/icons';
import React, { useMemo } from 'react'

import { Avatar, Table, Typography } from 'antd'
import AddonIcon from "assets/icons/addon.png";

const { Text, Title } = Typography;


export default function SubmittedKits({ submittedKits, preferenceCards,
    product, isLoading
}) {

    const data = useMemo(() => {
        return submittedKits.data?.map(submittedKit => {

            for (const preferenceCard of preferenceCards ?? []) {
                for (const kit of preferenceCard?.kits ?? []) {
                    for (const lot of kit.lots || []) {
                        if (String(lot.facilityProductId) === submittedKit.facilityProductId) {
                            submittedKit.sku = kit.inventoryProductId;
                            submittedKit.lotNumber = lot.lotNumber;
                            submittedKit.productName = kit.productName
                            break;
                        }
                    }
                }
            }



            return submittedKit
        })
    }, [submittedKits, preferenceCards])

    const columns = [
        {
            title: "SKU",
            key: "inventoryProductId",
            width: 160,
            render: (kit) => {
                return (
                    <div
                        style={{
                            display: "flex",
                            gap: 8,
                            alignItems: "center",
                        }}
                    >
                        <Text
                            style={{
                                fontSize: 16,
                            }}
                        >
                            {kit?.inventoryProductId}
                        </Text>
                        <CheckCircleOutlined style={{ fontSize: 20, color: "#52c41a" }} />
                    </div>
                );
            },
        },
        {
            title: "Description",
            key: "productName",
            render: (kit) => {

                return (
                    <div
                        style={{
                            display: "flex",
                            gap: 8,
                            alignItems: "center",
                        }}
                    >
                        <Text
                            style={{
                                fontSize: 16,
                            }}
                        >
                            {kit?.productName}
                        </Text>
                    </div>
                );
            },
        },
        {
            title: "Lot",
            key: "lot",
            width: 250,
            render: (kit, _, index) => {

                return <Text
                    style={{
                        fontSize: 16,
                    }}
                >
                    {kit?.lotNumber}
                </Text>
            },
        },
        {
            title: "Qty",
            width: 200,

            render: (it, _, index) => {
                return (
                    <div>{Math.abs(it?.qty ?? 0)}</div>
                );
            },
        },
    ];


    return (
        <>
            <div className="kitSearch">
                <div className="userInfo">
                    <Avatar
                        size={45} icon={<UserOutlined />}
                        style={{ backgroundColor: "#f5f2ef", }}
                        src={AddonIcon}
                    />
                    <div className="names">
                        <Title>{product}</Title>
                    </div>
                </div>
                <div
                    className="controls"
                    style={{
                        display: "flex",
                        gap: 16,
                    }}
                >

                </div>
            </div>
            <Table
                tableLayout="auto"
                locale={{
                    emptyText: "No Items",
                }}
                loading={isLoading}
                dataSource={data ?? []} // Replace with data
                columns={columns}
                pagination={false}
                scroll={{ x: true }}
                style={{ marginBottom: 16 }}
            />
        </>
    )
}
